import { i18n } from '@zet/localization'

import en from './en.json'
import hi from './hi.json'

const availableLanguages = [
  { name: 'English', code: 'en' },
  { name: 'हिन्दी', code: 'hi' },
]

const localizationObj = {
  en,
  hi,
}

i18n.store(localizationObj)

export { availableLanguages, i18n }
